<template lang="pug">
  div
</template>

<script>
export default {
  created () {
    let token = this.$route.params.token
    this.$router.push({ name: 'order_edit', params: { token: token } })
  }
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Reload/index.vue